// extracted by mini-css-extract-plugin
export default {"container":"admins-create_container__omQyv","form":"admins-create_form__L5fMF","sectionContent":"admins-create_sectionContent__zbcki","section":"admins-create_section__-jcg9"};